export default {
    key: 'success',
    Things: 'Things',
    'Upload Date': 'Upload Date',
    Duration: 'Duration',
    Features: 'Features',
    'Edit Image': 'Edit Image',
    Title: 'Title',
    Description: 'Description',
    'New Image': 'New Image',
    Image: 'Image',
    Images: 'Images',
    Tags: 'Tags',
    'Save & close': 'Save & close',
    Type: 'Type',
    Edit: 'Edit',
    Delete: 'Delete',
    'Go back': 'Go back',
    'New item': 'New item',
    Id: 'Id',
    'Upload Image': 'Upload Image',
    'Layouts Timeline': 'Layouts Timeline',
    Date: 'Date',
    'Back stage': 'Back stage',
    Front: 'Front',
    items: 'items',
    'Navigate: Things': 'Navigate: Things',
    Orientation: 'Orientation',
    back: 'back',
    front: 'front',
    gallery: 'gallery',
    preview: 'preview',
    New: 'New',
    search: 'search',
};
